export default __webpack_public_path__ + "static/media/diningRoom.42d718bc.jpg";